import React, {Component} from "react";
import InlineSVG from "react-inlinesvg";
import Style from "./FJResourcesRatioItem.module.less";
import classNames from 'classnames';

class FJResourcesRatioItem extends Component {
  render() {
    const {active, icon, platform} = this.props;
    const {onClick, onMouseEnter, onMouseLeave} = this.props;
    return (
      <div className={classNames(Style.ratio_item, {[Style.ratio_item_active]: active})}
           onClick={onClick}
           onMouseEnter={onMouseEnter}
           onMouseLeave={onMouseLeave}>
        <div className={Style.ratio_svg}>
          <InlineSVG src={icon}/>
        </div>
        <div className={Style.ratio_platform_svg}>
          <InlineSVG src={platform}/>
        </div>
      </div>
    )
  }
}

export default FJResourcesRatioItem;
